var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoVehicleSelectedForComparison(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 171,
    viewBox: "0 0 184 171",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "jlxb1y3yta",
    d: "M0 170.21h183.308V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.258 166.552V147.21c0-29.15-9.303-52.782-20.778-52.782H59.41c-11.474 0-20.777 23.631-20.777 52.782v19.343h126.625z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ku01pgsrpb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jlxb1y3yta"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#ku01pgsrpb)",
    d: "M93.931 96.826h18.38V66.783h-18.38z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#ku01pgsrpb)",
    d: "M93.931 96.826h18.38V66.783h-18.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.567 20.135c0 11.12-9.015 20.135-20.135 20.135-11.12 0-20.136-9.015-20.136-20.135C64.296 9.015 73.311 0 84.431 0c11.12 0 20.136 9.015 20.136 20.136",
    fill: "#000",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.46 23.143c.646 7.145-4.265 13.43-10.969 14.035-6.704.607-12.663-4.693-13.309-11.839-.647-7.145 4.264-13.429 10.968-14.036 6.705-.606 12.664 4.694 13.31 11.84",
    fill: "#000",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.349 34.337c.764 8.44-5.46 15.901-13.9 16.665-8.442.764-15.903-5.46-16.666-13.9-.764-8.441 5.46-15.903 13.9-16.666 8.44-.764 15.902 5.46 16.666 13.9",
    fill: "#000",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.132 54.39c.577 6.376-4.124 12.014-10.501 12.591-6.377.576-12.014-4.125-12.591-10.502-.577-6.377 4.125-12.014 10.502-12.59 6.376-.578 12.014 4.124 12.59 10.501M84.73 39.481c.49 5.407-3.497 10.188-8.904 10.677-5.408.49-10.188-3.497-10.677-8.906-.49-5.407 3.497-10.187 8.904-10.676 5.408-.49 10.189 3.498 10.678 8.905",
    fill: "#000",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.628 47.957c.297 1.46.47 2.989.47 4.575 0 2.825-.515 5.485-1.408 7.848 3.473-.35 6.177-3.031 6.177-6.291 0-2.96-2.229-5.438-5.239-6.132M82.002 31.938S66.727 68.043 79.92 77.763c13.191 9.721 23.26 5.208 30.203 0 6.943-5.207 9.026-12.15 9.026-12.15s-5.902 2.43-5.902-3.472c0-5.9 3.82-17.01 1.041-20.829-2.777-3.819-12.845-12.15-32.285-9.374",
    fill: "#FFF",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.002 31.938S66.727 68.043 79.92 77.763c9.25 6.816 16.962 6.634 23.14 4.122",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.951 40.425s4.325-4.295 8.37-.662",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.696 45.685c-.429.911-1.304 1.4-1.954 1.094-.65-.306-.83-1.293-.4-2.203.427-.912 1.302-1.4 1.953-1.094.65.306.83 1.293.401 2.203",
    fill: "#000",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.065 40.187s5.62-2.355 8.007 2.53",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.104 47.074c-.43.91-1.304 1.4-1.954 1.094-.651-.306-.83-1.293-.401-2.203.428-.912 1.303-1.401 1.954-1.094.65.306.83 1.293.4 2.203",
    fill: "#000",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#080717",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#ku01pgsrpb)",
    d: "m89.9 45.478-3.386 5.468 3.647 2.343M91.983 61.36s6.248.781 10.674-8.071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.004 100.156H95.313a4.958 4.958 0 0 1-4.958-4.958v-4.666a4.957 4.957 0 0 1 4.958-4.957h13.691a4.958 4.958 0 0 1 4.958 4.957v4.666a4.958 4.958 0 0 1-4.958 4.958",
    fill: "#000",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.371 79.658a39.116 39.116 0 0 0 2.751-1.895c6.942-5.207 9.025-12.15 9.025-12.15",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.78 97.356c-.017 3.161-1.534 5.957-3.862 7.741a2.882 2.882 0 0 0-1.117 2.258c-.008 1.5 1.125 2.722 2.58 2.894l22.44.12-.32 59.841-59.84-.32.123-23.237c.053-.129.115-.243.183-.359a.306.306 0 0 0 .023-.043c.074-.11.145-.22.228-.319.003-.007.015-.014.02-.024.151-.182.325-.34.515-.48.032-.024.06-.052.094-.07.064-.047.14-.083.208-.124a2.92 2.92 0 0 1 .231-.115c.065-.033.13-.056.193-.08.103-.033.204-.065.31-.09.057-.012.112-.029.166-.038.17-.025.335-.046.51-.045a2.896 2.896 0 0 1 2.261 1.12c1.782 2.331 4.578 3.847 7.737 3.863 5.418.03 9.836-4.344 9.864-9.76.03-5.42-4.342-9.836-9.76-9.865-3.162-.016-5.972 1.47-7.782 3.783a2.892 2.892 0 0 1-2.268 1.094 2.619 2.619 0 0 1-.509-.056.798.798 0 0 1-.166-.038 3.416 3.416 0 0 1-.308-.089c-.064-.025-.128-.056-.192-.083a1.735 1.735 0 0 1-.23-.12c-.068-.039-.144-.078-.207-.123-.034-.024-.062-.048-.095-.072a3.11 3.11 0 0 1-.509-.484c-.004-.012-.016-.018-.019-.026a2.665 2.665 0 0 1-.219-.317 3.036 3.036 0 0 1-.208-.407l.125-23.238 22.441.121c1.46-.157 2.607-1.367 2.615-2.867.006-.918-.432-1.729-1.097-2.265-2.309-1.813-3.8-4.622-3.782-7.786.028-5.416 4.446-9.789 9.867-9.76 5.418.03 9.785 4.45 9.756 9.865",
    fill: "#6176F4",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.238 167.554v-22.613h.003a2.943 2.943 0 0 1 2.932-2.735c.927 0 1.75.445 2.29 1.12a9.903 9.903 0 0 0 7.86 3.871c5.481 0 9.931-4.448 9.931-9.932 0-5.485-4.45-9.93-9.93-9.93a9.924 9.924 0 0 0-7.862 3.866 2.923 2.923 0 0 1-2.289 1.121 2.941 2.941 0 0 1-2.932-2.735h-.003v-22.609H50.53a2.939 2.939 0 0 1-2.64-2.918c0-.929.444-1.747 1.12-2.29 2.348-1.816 3.872-4.655 3.872-7.856 0-5.487-4.448-9.93-9.934-9.93-5.482 0-9.934 4.443-9.934 9.93 0 3.201 1.52 6.036 3.87 7.856a2.923 2.923 0 0 1 1.122 2.29 2.94 2.94 0 0 1-2.638 2.918H12.66v60.576h60.58z",
    fill: "#767575",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.336 148.02s.568 9.563.521 11.825c-.025 1.233-.526 7.261-6.543 7.958-6.021.697-16.417-.313-17.166-3.574-.75-3.26.562-4.142 2.006-5.022 1.446-.882 7.323-.998 8.847-.937 1.525.062 4.263-12.513 12.335-10.25",
    fill: "#FFF",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.336 148.02s.568 9.563.521 11.825c-.025 1.233-.526 7.261-6.543 7.958-6.021.697-16.417-.313-17.166-3.574-.75-3.26.562-4.142 2.006-5.022 1.446-.882 7.323-.998 8.847-.937 1.525.062 4.263-12.513 12.335-10.25z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.729 139.066s.676 10.953.567 12.855c-.076 1.339-.573 7.894-7.115 8.653-6.542.758-17.578 2.101-18.393-1.444-.815-3.543.344-6.945 1.914-7.903 1.57-.957 7.962-1.084 9.619-1.017 1.656.067 4.633-13.604 13.408-11.144",
    fill: "#FFF",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.729 139.066s.676 10.953.567 12.855c-.076 1.339-.573 7.894-7.115 8.653-6.542.758-17.578 2.101-18.393-1.444-.815-3.543.344-6.945 1.914-7.903 1.57-.957 7.962-1.084 9.619-1.017 1.656.067 4.633-13.604 13.408-11.144z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.2 131.576s.975 11.577.57 12.854c-.424 1.337-.576 7.894-7.118 8.653-6.542.759-17.578 2.1-18.393-1.443-.815-3.543.343-6.946 1.915-7.904 1.57-.958 7.96-1.084 9.618-1.017 1.657.067 4.633-13.603 13.408-11.143",
    fill: "#FFF",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.2 131.576s.975 11.577.57 12.854c-.424 1.337-.576 7.894-7.118 8.653-6.542.759-17.578 2.1-18.393-1.443-.815-3.543.343-6.946 1.915-7.904 1.57-.958 7.96-1.084 9.618-1.017 1.657.067 4.633-13.603 13.408-11.143z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.68 123.474c7.207 0 6.217 9.291 6.137 12.066-.04 1.39-.594 8.182-7.375 8.967-6.782.786-18.218 2.18-19.064-1.494-.844-3.674.356-7.198 1.985-8.192 1.627-.994 8.25-1.123 9.967-1.054 1.246.05 8.35.144 8.35-5.597 0-2.318-.174-4.696 0-4.696",
    fill: "#FFF",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.68 123.474c7.207 0 6.217 9.291 6.137 12.066-.04 1.39-.594 8.182-7.375 8.967-6.782.786-18.218 2.18-19.064-1.494-.844-3.674.356-7.198 1.985-8.192 1.627-.994 8.25-1.123 9.967-1.054 1.246.05 8.35.144 8.35-5.597 0-2.318-.174-4.696 0-4.696z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.632 117.612-.97 7.566s6.04 2.334 9.303 2.872c3.262.537 8.89 1.069 12.329.767 3.44-.301 7.185-1.024 8.703.29 1.518 1.314 2.577 3.262 1.404 4.882-1.173 1.62 1.958.559 1.958.559s3.165-.071 3.424 1.943c.26 2.014-.37 3.92-1.804 5.458-1.436 1.537-2.891 2.953-2.891 2.953s2.87.039 3.668 1.904c.796 1.866 1.362 3.456-.233 4.77-1.596 1.314-6.54 4.285-6.54 4.285l-2.338.562s2.623.825 2.652 2.564c.029 1.739-6.242 5.358-11.057 5.63-4.814.272-13.971 2.982-20.44-2.024-6.467-5.005-12.491-11.515-12.315-19.764.174-8.248 2.44-16.272 5.414-19.488 2.973-3.215 8.669-6.928 8.669-6.928l1.064 1.199z",
    fill: "#FFF",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.44 124.938s7.94 3.11 14.434 3.794c7.98.841 14.344-1.077 17.124.375 3.193 1.668 1.739 4.896-.276 6.458",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.453 138.497s8.44.206 13.694-.821c6.096-1.192 8.628-2.875 10.211-3.128 2.551-.408 3.93 1.987 3.575 3.663-.354 1.676-2.63 5.85-7.675 8.078-7.737 3.417-20.412 1.646-20.412 1.646",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.974 158.146c.665.268 14.972-1.398 18.625-3.478 3.653-2.079 6.392-3.888 6.126-6.086-.384-3.177-5.205-3.34-5.205-3.34",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#ku01pgsrpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.14 115.324s-1.97 1.24-6.44 4.892c-6.83 5.577-9.884 19.029-5.976 29.604 4.063 10.995 14.175 15.419 17.833 15.705 5.51.433 16.468-1.388 21.155-4.007 4.689-2.618 1.045-5.15 1.045-5.15",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#ku01pgsrpb)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVehicleSelectedForComparison);
export default __webpack_public_path__ + "static/media/no-vehicle-selected-for-comparison.d14d83a7af3fa7589d62e2643e07daf4.svg";
export { ForwardRef as ReactComponent };